var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.formatDate(_vm.current_date))+" "),(_vm.today === _vm.date)?_c('span',[_c('br'),_c('span',{staticClass:"badge rounded-pill font-size-11 badge-soft-secondary mr-1"},[_vm._v("Today")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }